import { put, call, takeEvery, select } from 'redux-saga/effects';
import { getPriceByUrl } from 'yoda-interfaces/lib/Product/ProductPricingApi';
import { X_CLIENT_SOURCE_PDP } from 'yoda-site-components/lib/common/Constants';
import { getDisableBYDeliveryDateFlag } from 'yoda-site-components/lib/selectors/byDeliveryDateSelector';
import { selectFeatureFlags } from 'yoda-site-components/lib/selectors/ContextSelector';
import { getLocalizationZipcode } from 'yoda-site-components/lib/helpers/Utils/utils';
import { getURLParameterBykey } from 'yoda-core-components/lib/helpers/Utils/Utils';
import {
    BUNDLE_ITEMOFFERING_GET_SUCCESS,
    BUNDLE_ITEMOFFERING_GET_ERROR,
    BUNDLE_ITEMOFFERING_GET_REQUEST,
} from '../actionTypes/BundleItemOfferingActionTypes';

function* bundleItemOfferingSaga(item) {
    try {
        const disableBYDeliveryDate = yield select(getDisableBYDeliveryDateFlag);
        const featureFlags = yield select(selectFeatureFlags);
        const { enableLocalization = false } = featureFlags;

        const utmSourceParam = !__SERVER__
            ? getURLParameterBykey('utm_source', window?.location?.search)
            : '';
        const disableLocParam = !__SERVER__
            ? getURLParameterBykey('disableLoc', window?.location?.search)
            : '';
        const geoZipCode = getLocalizationZipcode();
        const offering = yield call(getPriceByUrl, {
            url: item.payload.url,
            params: {
                ...item.payload.params,
                ...(enableLocalization && { GPA: utmSourceParam === 'google' }),
                ...(enableLocalization &&
                    item.payload.warehouseClass && { warehouseClass: item.payload.warehouseClass }),
                ...(enableLocalization &&
                    geoZipCode && {
                        geoZip: geoZipCode,
                    }),
                ...(disableLocParam && { disableLoc: disableLocParam }),
            },
            xClientSource: !disableBYDeliveryDate ? X_CLIENT_SOURCE_PDP : null,
        });
        yield put({
            type: BUNDLE_ITEMOFFERING_GET_SUCCESS,
            payload: { ppId: item.payload.id, itemOffering: offering },
        });
    } catch (error) {
        yield put({ type: BUNDLE_ITEMOFFERING_GET_ERROR, error });
    }
}

const watchProductPricingRequest = function* watchProductPricingRequest() {
    yield takeEvery(BUNDLE_ITEMOFFERING_GET_REQUEST, bundleItemOfferingSaga);
};

watchProductPricingRequest.sagaName = 'productPricingRequest';

export default watchProductPricingRequest;
